export const satoshisToBtc = (satoshis: number) => satoshis / 100000000;
